// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"710":"7f34891d","765":"45b62a29","868":"27d1209e","973":"28571dc5"}[chunkId] + ".css";
};